// Do NOT add "use client" to this file
import { IBrandTileBrandReviewsResponse } from "@faire/web-api/indigofair/data/IBrandTileBrandReviewsResponse";
import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { StrictLocalizeFunction } from "@faire/web/common/localization";

import { getAltTag } from "@faire/retailer/features/Marketplace/utils";
import { PRODUCT_TILE_TYPE_MAP } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/__internal__/common";
import { ProductTileImageProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import { ProductTileType } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { getHelmetData } from "@faire/retailer/views/search-v2/util/getHelmetData";

export const searchPageProductTileImagePropsAdapter = ({
  productName,
  strictLocalize,
  productTileType,
  productSearchString,
  spellCorrectedQuery,
  isFromDiscoverURL,
  reviews,
  shouldUseLazyImageLoading,
  showVerticalImagery,
  primaryImage,
  onLoad,
}: {
  productName: string | undefined;
  strictLocalize: StrictLocalizeFunction;
  productTileType: ProductTileType | undefined;
  productSearchString: string;
  spellCorrectedQuery: string | undefined;
  isFromDiscoverURL: boolean;
  reviews: IBrandTileBrandReviewsResponse.IBrandTileBrandReview[] | undefined;
  shouldUseLazyImageLoading: boolean;
  showVerticalImagery: boolean;
  primaryImage: IImage;
  onLoad: (() => void) | undefined;
}): ProductTileImageProps => {
  const finalQuery =
    spellCorrectedQuery === undefined
      ? productSearchString
      : spellCorrectedQuery;

  const { title } = getHelmetData(
    finalQuery,
    isFromDiscoverURL,
    strictLocalize,
    reviews
  );

  const templateAltTag = getAltTag(
    {
      pageType: productTileType
        ? PRODUCT_TILE_TYPE_MAP[productTileType]
        : undefined,
      title,
      productName,
    },
    strictLocalize
  );

  const imageAltText = primaryImage.alt_text ?? templateAltTag;

  return {
    image: primaryImage,
    imageAltText,
    shouldUseLazyImageLoading,
    showVerticalImagery,
    onLoad,
    disableRedirectToPdp: false,
  };
};
